import { createNode } from '@glueapp/graph-types';
import { GmailIntegration } from './GmailIntegration';
import { MessageDetail } from './types';

export const GetGmailEmailById = createNode({
    id: 'Get GMail Email by ID',
    name: 'Get GMail Email by ID',
    description: 'Get an Email based on its ID',
    aiDescription:
        'Requires the Google Mail integration to be connected. Takes an "ID" (string) input port for the Gmail message ID. Outputs an "Email" (object) port with properties: id, threadId, labelIds, snippet, historyId, and internalDate.',
    category: 'Google Mail',
    color: '#ee4237',
    integration: GmailIntegration,
    inPorts: { ID: { kind: 'string' } },
    outPorts: {
        Email: {
            kind: 'object',
            restriction: 'exact',
            properties: {
                id: { kind: 'string' },
                threadId: { kind: 'string' },
                labelIds: { kind: 'array', subType: { kind: 'string' } },
                snippet: { kind: 'string' },
                historyId: { kind: 'string' },
                internalDate: { kind: 'string' },
            },
        },
    },
    isAsync: true,
    execute: async function (input) {
        const id = input.inPorts.ID as string;
        try {
            const response = await input.integration.callIntegration<MessageDetail>({
                url: `https://gmail.googleapis.com//gmail/v1/users/me/messages/${id}`,
                params: {
                    format: 'full',
                },
            });
            return { output: { Email: response.data as {} } };
        } catch {
            return { output: { Email: '' } };
        }
    },
});
